import BaseController from './BaseController';
import { isStorageAvailable } from '../helpers/Util';
import AppConfig from '../appConfig';
import { HelpTourNewUserSteps, HelpTourVersions } from '../enums/HelpTourDefinitions';

// TODO: Remove this block when we release this version
const STORAGE = window.localStorage;
const IS_STORAGE_AVAILABLE = isStorageAvailable(STORAGE);
const HELP_TOUR_STORAGE_KEY = `${AppConfig.constants.environment}-${AppConfig.constants.helpTourCompletedFlagName}`;
const HELP_TOUR_VERSION_STORAGE_KEY = `${AppConfig.constants.environment}-${AppConfig.constants.helpTourVersionFlagName}`;

class HelpController extends BaseController {
    static get name() {
        return 'HelpController';
    }

    static getInstance(options) {
        return new HelpController(options);
    }

    onActivate() {
        this.bindGluBusEvents({
            HELP_TOUR_STATUS_REQUEST: this.onHelpTourStatusRequest,
            HELP_TOUR_STATUS_UPDATE_REQUEST: this.onHelpTourStatusUpdateRequest,
            USER_INFO_LOAD_SUCCESS: this.onUserInfoLoadSuccess,
        });

        this.isHelpTourDone = undefined;
        this.tourVersion = undefined;
        this.currentUser = undefined;
        this.pendingTourRequest = false;
    }

    onUserInfoLoadSuccess(userInfo) {
        this.currentUser = userInfo;
        // If a tour request came in early, run it now
        if (this.pendingTourRequest) {
            this.pendingTourRequest = false;
            this.onHelpTourStatusRequest();
        }
    }

    onHelpTourStatusRequest() {
        if (!this.currentUser || !this.currentUser.preferences) {
            this.pendingTourRequest = true;
            return;
        }
        // Read existing flags from localStorage (legacy users)
        // TODO: remove this block when we release this version
        let localIsDone = false;
        const prefs = this.currentUser.preferences;

        if (IS_STORAGE_AVAILABLE) {
            localIsDone = STORAGE.getItem(HELP_TOUR_STORAGE_KEY);
            if (localIsDone === null) {
                if (prefs.walkthroughs) {
                    localIsDone = prefs.walkthroughs.map_help_tour_v1 === true;
                } else localIsDone = false;
            }
        }

        this.bus.emit('USER_PREFERENCES_UPDATE_REQUEST', {
            walkthroughs: {
                ...prefs.walkthroughs,
                map_help_tour_v1: Boolean(localIsDone),
            },
        });

        if (this.isHelpTourDone === undefined) {
            this.isHelpTourDone = Boolean(localIsDone);
            this.bus.emit('HELP_TOUR_STATUS_UPDATE_REQUEST', {
                isDone: this.isHelpTourDone,
                tourVersion: HelpTourVersions.V1,
            });
        }

        if (this.isHelpTourDone === false) {
            this.bus.emit('HELP_TOUR_START_REQUEST', { tourSteps: HelpTourNewUserSteps });
        }
        // TODO: remove this block when we release this version
        if (IS_STORAGE_AVAILABLE) {
            STORAGE.removeItem(HELP_TOUR_VERSION_STORAGE_KEY);
            STORAGE.removeItem(HELP_TOUR_STORAGE_KEY);
        }
    }

    onHelpTourStatusUpdateRequest(params) {
        if (!this.currentUser || !this.currentUser.preferences) return;

        this.isHelpTourDone = params.isDone;

        if (params.tourVersion) {
            this.tourVersion = params.tourVersion;
        }

        this.bus.emit('USER_PREFERENCES_UPDATE_REQUEST', {
            walkthroughs: {
                ...this.currentUser.preferences.walkthroughs,
                map_help_tour_v1: this.isHelpTourDone,
            },
        });
    }

    onDeactivate() {
        this.unbindGluBusEvents();
    }
}

export default HelpController;
